import { render, staticRenderFns } from "./ConfigureShiftOld.vue?vue&type=template&id=0c58a290&scoped=true"
import script from "./ConfigureShiftOld.vue?vue&type=script&lang=js"
export * from "./ConfigureShiftOld.vue?vue&type=script&lang=js"
import style0 from "./ConfigureShiftOld.vue?vue&type=style&index=0&id=0c58a290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c58a290",
  null
  
)

export default component.exports